<style>
    :host ::ng-deep .s-s-l-badgePush .p-badge {
        top: -8px;
        right: -5px;
    }

    .s-s-l-badgePush .p-badge {
        top: -8px;
        right: -5px;
    }

    :host ::ng-deep .s-s-l-chat .p-badge {
        top: -8px;
        right: -5px;
    }

    .s-s-l-chat .p-badge {
        top: -8px;
        right: -5px;
    }
</style>
<div class="layout-topbar ">
    <div class="topbar-start pl-4 p-0 md:pl-0 col-2" *ngIf="isMobile">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>
    </div>
    <div #topbarMiddle class="topbar-middle p-0 col-7 overflow-x-auto white-space-nowrap" *ngIf="isMobile">
        <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="topbar-end pr-4  md:pr-0 col-3" *ngIf="isMobile">
        <ul class="topbar-menu">
            <li class="topbar-profile">
                <button type="button" class="p-link text-2xl" (click)="onChatButtonClick()">
                    <div class="profile-wrapper relative flex align-items-center justify-content-center w-full h-full">
                        <i class="bi bi-chat-fill" style="position: absolute;left: 13%;"></i>
                        <p-badge *ngIf="commentsNaoLidos > 0 && !isLoading" [value]="commentsNaoLidosLabel" severity="danger"
                            class="s-s-l-chat" styleClass="absolute -top-2 ss-badge-circle"></p-badge>
                    </div>
                </button>
            </li>
            <li class="topbar-profile">
                <button type="button" class="p-link text-2xl" (click)="onProfileButtonClick()">
                    <div class="profile-wrapper relative flex align-items-center justify-content-center w-full h-full">
                        <i class="bi bi-bell-fill" style="position: absolute;left: 13%;"></i>

                        <p-badge *ngIf="pushsNaoLidos > 0 && !isLoading" [value]="pushsNaoLidosLabel" severity="danger"
                            class="s-s-l-badgePush 123" styleClass="absolute -top-2 ss-badge-circle">
                        </p-badge>
                    </div>
                </button>
            </li>
        </ul>
    </div>





    <div class="topbar-start pl-4 md:pl-0" *ngIf="!isMobile">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>
        <app-breadcrumbs></app-breadcrumbs>
    </div>

    <div class="topbar-end pr-4 md:pr-0" *ngIf="!isMobile">
        <ul class="topbar-menu">
            <li class="topbar-profile">
                <button type="button" class="p-link text-2xl" (click)="onChatButtonClick()">
                    <div class="profile-wrapper relative flex align-items-center justify-content-center w-full h-full">
                        <i class="bi bi-chat-fill" style="position: absolute;left: 13%;"></i>
                        <p-badge *ngIf="commentsNaoLidos > 0 && !isLoading" [value]="commentsNaoLidosLabel" severity="danger"
                            class="s-s-l-chat" styleClass="absolute -top-2 ss-badge-circle"></p-badge>
                    </div>
                </button>
            </li>
            <li class="topbar-profile">
                <button type="button" class="p-link p-0 text-2xl" (click)="onProfileButtonClick()">
                    <span class="profile-wrapper relative w-2rem h-2rem border-circle grid place-items-center">
                        <i class="bi bi-bell-fill" style="position: absolute;top: 25%;left: 13%;"></i>

                        <p-badge *ngIf="pushsNaoLidos > 0 && !isLoading" [value]="pushsNaoLidosLabel"
                            severity="danger" class="s-s-l-badgePush " styleClass="absolute top-0 ss-badge-circle">
                        </p-badge>
                    </span>
                </button>
            </li>
        </ul>
    </div>

</div>